import { Component, OnInit } from '@angular/core';
import { SaleReturnProductService } from '../../services/sale-return-product.service';
import { SaleReturnService } from '../../services/sale-return.service';
import { UserService } from '../../../common/services/user.service';

import * as moment from 'moment/moment';
import * as _ from 'lodash/lodash';
declare let alasql;

@Component({
  selector: 'app-list-sale',
  templateUrl: './list-sale-return.component.html',
  styleUrls: ['./list-sale-return.component.css'],
  providers:[SaleReturnService, SaleReturnProductService, UserService]
})
export class ListSaleReturnComponent implements OnInit {
  p: number = 1;
  totalItems: number = 0;
  salesReturn: any = [];
  filters:any = {

  };
  from:any;
  until:any;
  users: any = [];
  exportParams:any ={};
  constructor(private saleReturnService: SaleReturnService, private saleReturnProductService:SaleReturnProductService, private userService:UserService) { }

  ngOnInit() {
    this.getSalesReturn();
    this.getUsers();
  }

  getUsers(){
    this.userService.query({})
        .subscribe((users) => {
            this.users = users;
            this.users.unshift({id:null, username:"Ninguno"});
        });
  }
  
  getSalesReturn(){
    if (this.filters && this.filters.createdBy == null){
      delete this.filters.createdBy;
    }
    var params = {
      where: _.cloneDeep(this.filters),
      sort: 'id DESC',
      skip: (this.p-1)*10,
      limit: 10
    };
    if (this.from && moment(this.from, "DD-MM-YYYY").format("YYYY-MM-DD") != 'Invalid date'){
      params.where.date = params.where.date? params.where.date:{};
      params.where.date[">="] = moment(this.from, "DD-MM-YYYY").format("YYYY-MM-DD");
    }
    if (this.until && moment(this.until, "DD-MM-YYYY").format("YYYY-MM-DD") != 'Invalid date'){
      params.where.date = params.where.date? params.where.date:{};
      params.where.date["<="] = moment(this.until, "DD-MM-YYYY").format("YYYY-MM-DD");
    }
    this.exportParams = params;
    this.saleReturnService.query(params)
      .subscribe((salesReturn) => {
          this.salesReturn = salesReturn;
          let countParams = {
            where: _.cloneDeep(params.where),
          };
          this.saleReturnService.count(countParams)
          .subscribe((count) => {
            this.totalItems = count.count;
          });
          this.getProductsFromSale();
      });
  }

  getProductsFromSale(){
    let params = {
      where:{
        salereturn_id:_.compact(this.salesReturn.map(e => e.id))
      }
    };
    this.saleReturnProductService.query(params)
    .subscribe((saleReturnProducts) => {
      let groupedSaleProducts = _.groupBy(saleReturnProducts, (element)=> {return element.salereturn.id});
      this.salesReturn.forEach( (s) =>{
        s.description = "";
        if (groupedSaleProducts[s.id] && groupedSaleProducts[s.id].length > 0){
          groupedSaleProducts[s.id].forEach((e, index) =>{
            if (index < 3){
              s.description += e.labeledproduct.name + ", ";
            }
          });
          s.description = s.description .slice(0, -2) ;
          if (groupedSaleProducts[s.id].length >= 3){
            s.description += "..."
          }
        }
      });
    });
  }

  exportSalesReturnToExcel(){
    var options = {   
        fieldSeparator: ';',
        quoteStrings: '"',
        decimalseparator: '.',
        showLabels: false,
        showTitle: false,
        useBom: false,   
        bookType:'xlsx' ,  
        cellStyles:true,
    };             
    let report = [
          {
              field1:"Número",
              field2:"Número con serie",
              field3:"Fecha",
              field4:"Productos",
              field5:"Total",
              field6:"Razón",
              field7:"Usuario",
              field8:"Ticket de venta original",
              field9:"Método de pago",
              
          }
      ]
      delete this.exportParams.skip;
      delete this.exportParams.limit;
      this.saleReturnService.query(this.exportParams)
               .subscribe((salesreturn) => {
      let paramsProducts = {
        where: {
          salereturn_id: salesreturn.map(e => e.id)
        }
      }
      this.saleReturnProductService.query(paramsProducts)
      .subscribe((salereturnProducts) => {
        let groupedSaleProducts = _.groupBy(salereturnProducts, (element)=> {return element.salereturn.id})
        salesreturn.forEach( (s) =>{
          if (groupedSaleProducts[s.id] && groupedSaleProducts[s.id].length > 0){
           s.description = ""; 
           groupedSaleProducts[s.id].forEach((e, index) =>{
             if (index < 3){
               if (e.labeledproduct){
                s.description += e.labeledproduct.name + ", ";
               }
             }
           });
           s.description = s.description .slice(0, -2) ;
           if (groupedSaleProducts[s.id].length >= 3){
             s.description += "..."
           }
          }
        });
        salesreturn.forEach(salereturn =>{
                  var row = {
                      field1:salereturn.number,
                      field2:salereturn.number_with_serie,
                      field3:salereturn.date?moment(salereturn.date).format("DD-MM-YYYY"):"",
                      field4:salereturn.description,
                      field5:salereturn.total,
                      field6:salereturn.reason,
                      field7:salereturn.createdBy.username,
                      field8:salereturn.sale?salereturn.sale.number_with_serie:"",
                      field9:salereturn.sale?salereturn.sale.method_of_payment:""
                  }
                  report.push(row);
                
              });
              
              var mystyle = {   
                  headers:true,       
                  columns:    
                      [{columnid:'field1',width:50,title: ''},   
                      {columnid:'field2',width:100,title: ''},
                      {columnid:'field3',width:100,title: 'LISTADO DE DEVOLUCIONES'},
                      {columnid:'field4',width:300,title: ''},
                      {columnid:'field5',width:100,title: ''},
                      {columnid:'field6',width:200,title: ''},
                      {columnid:'field7',width:100,title: ''},
                      {columnid:'field8',width:100,title: ''},
                      {columnid:'field8',width:100,title: ''}
                      
                      ],
                  /*header*/
                
                  column: {  
                      style:{
                          Alignment:{
                              Horizontal:"Center",
                              Vertical:"Center",  
                              WrapText:1
                              
                          },
                          Font:{
                              Bold:"1",
                              Color:"#000000",
                              Size:10
                          },
                          
                          Interior:{
                              Color:"#7CEECE",
                              Pattern:"Solid"
                          }
                      }},
                cells: {    
                      0:{
                          0:{style:{
                              Interior:{ 
                                  Color:"#95a5a6",
                                  Pattern:"Solid",
                                      },
                              Alignment:{
                                Horizontal:"Center",
                                Vertical:"Center",
                                WrapText: 1,
                                  },  
                              Font:{
                                  Size:10,
                                  Bold:"1",
                                  Color:"#000000",
                              },                        
                              }  
                          },
                          1:{style:{
                              Interior:{ 
                                  Color:"#95a5a6",
                                  Pattern:"Solid"
                                      },
                              Alignment:{
                                  Horizontal: 'Center', 
                                  Vertical: 'Center',
                                  WrapText: 1, 
                          },  
                              Font:{
                                      Size:10,
                                      Bold:"1",
                                      Color:"#000000",
                              },            
                                  }
                          },
                          2:{style:{
                              Interior:{ 
                                  Color:"#95a5a6",
                                  Pattern:"Solid"
                                      },
                              Alignment:{
                                  Horizontal: 'Center', 
                                  Vertical: 'Center',
                                  WrapText: 1, 
                                      }, 
                              Font:{
                                  Size:10,
                                  Bold:"1",
                                  Color:"#000000",
                          }                
                                  }
                              },
                          3:{style:{
                              Interior:{ 
                                  Color:"#95a5a6",
                                  Pattern:"Solid"
                                      },
                              Alignment:{
                                  Horizontal: 'Center', 
                                  Vertical: 'Center',
                                  WrapText: 1,
                                      },
                              Font:{
                                  Size:10,
                                  Bold:"1",
                                  Color:"#000000",
                          },            
                                    
                                  }
                              },
                          4:{style:{
                              Interior:{ 
                                  Color:"#95a5a6",
                                  Pattern:"Solid"
                                      },
                              Alignment:{
                                  Horizontal: 'Center', 
                                  Vertical: 'Center',
                                  WrapText: 1, 
                                      },
                              Font:{
                                  Size:10,
                                  Bold:"1",
                                  Color:"#000000",
                          },                           
                                  }
                              },
                          5:{style:{
                              Interior:{ 
                                  Color:"#95a5a6",
                                  Pattern:"Solid"
                                          },
                              Alignment:{
                                  Horizontal: 'Center', 
                                  Vertical: 'Center',
                                  WrapText: 1, 
                              },
                              Font:{
                                  Size:10,
                                  Bold:"1",
                                  Color:"#000000",
                          },                           
                                  }
                              },  
                              6:{style:{
                                  Interior:{ 
                                      Color:"#95a5a6",
                                      Pattern:"Solid"
                                              },
                                  Alignment:{
                                      Horizontal: 'Center', 
                                      Vertical: 'Center',
                                      WrapText: 1, 
                                  },
                                  Font:{
                                      Size:10,
                                      Bold:"1",
                                      Color:"#000000",
                              },                           
                                      }
                                  },  
                                  7:{style:{
                                      Interior:{ 
                                          Color:"#95a5a6",
                                          Pattern:"Solid"
                                                  },
                                      Alignment:{
                                          Horizontal: 'Center', 
                                          Vertical: 'Center',
                                          WrapText: 1, 
                                      },
                                      Font:{
                                          Size:10,
                                          Bold:"1",
                                          Color:"#000000",
                                  },                           
                                          }
                                      },
                                      8:{style:{
                                          Interior:{ 
                                              Color:"#95a5a6",
                                              Pattern:"Solid"
                                                      },
                                          Alignment:{
                                              Horizontal: 'Center', 
                                              Vertical: 'Center',
                                              WrapText: 1, 
                                          },
                                          Font:{
                                              Size:10,
                                              Bold:"1",
                                              Color:"#000000",
                                      },                           
                                              }
                                          },  
                      }   
                },
          };
          alasql.promise('SELECT * INTO XLSXML("Devoluciones_'+moment().format('DD-MM-YYYY')+'.xls",?) FROM ?',[mystyle,report])
          .then(function(data){
              console.log('Data saved');
          }).catch(function(err){
              console.log('Error:', err);
          });
        });
      });
    }
}



// WEBPACK FOOTER //
// ./src/app/salesreturn/components/list-sale-return/list-sale-return.component.ts